import { v4 as uuidv4 } from 'uuid';

import { AppDispatch } from '@/store';
import { RecentSearch } from '@/types/Algolia';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const LOCAL_STORAGE_KEY = 'recentSearches';

export const fetchRecentSearches = createAsyncThunk<RecentSearch[]>('recentSearch/fetchRecentSearches', async () => {
  const storedSearches = localStorage.getItem(LOCAL_STORAGE_KEY);
  const searches: RecentSearch[] = storedSearches ? JSON.parse(storedSearches) : [];
  const sliceedSearches: RecentSearch[] = searches.reverse().slice(-3);
  return sliceedSearches.reverse();
});

export const addSearchQuery = createAsyncThunk<RecentSearch, RecentSearch, { dispatch: AppDispatch }>(
  'recentSearch/addSearchQuery',
  async newSearch => {
    const storedSearches = localStorage.getItem(LOCAL_STORAGE_KEY);
    let searches: RecentSearch[] = storedSearches ? JSON.parse(storedSearches) : [];

    if (!searches.some(s => s.searchText === newSearch.searchText)) {
      searches = [
        { searchItemKey: uuidv4(), searchText: newSearch.searchText, link: newSearch.link, isLink: newSearch.isLink },
        ...searches,
      ];
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(searches));
    }
    return newSearch;
  }
);

export const deleteRecentSearch = createAsyncThunk<string, string, { dispatch: AppDispatch }>(
  'recentSearch/deleteRecentSearch',
  async searchKey => {
    const storedSearches = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (storedSearches) {
      const searches = JSON.parse(storedSearches).filter((s: RecentSearch) => s.searchItemKey !== searchKey);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(searches));
    }
    return searchKey;
  }
);

const recentSearchSlice = createSlice({
  name: 'recentSearch',
  initialState: {
    searches: [] as RecentSearch[],
    status: 'idle',
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchRecentSearches.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchRecentSearches.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.searches = action.payload;
      })
      .addCase(addSearchQuery.fulfilled, (state, action) => {
        if (!state.searches.some(s => s.searchItemKey === action.payload.searchItemKey)) {
          state.searches.unshift(action.payload);
          state.searches = state.searches.slice(0, 10);
        }
      })
      .addCase(deleteRecentSearch.fulfilled, (state, action) => {
        state.searches = state.searches.filter(search => search.searchItemKey !== action.payload);
      });
  },
});

export default recentSearchSlice;
